const metaData = {
  teamDetails : {
      gb : {
          dp : require("../images/member/gb.jpg"),
          fb : "",
          insta : "",
          role : "Owner",
          exp: "",
          name: "Gourav Bandyopadhyay"
      },
      shibu : {
          dp : require("../images/member/shibu.jpg"),
          fb : "https://www.facebook.com/shibu.saha.7982",
          insta : "https://www.instagram.com/shibu8983/",
          role : "Hybrid",
          exp: "",
          name: "Shibu Saha"
      },
      saptadip : {
          dp : require("../images/member/SAPTADIP.webp"),
          fb : "https://www.facebook.com/saptadip.dutta.9",
          insta : "https://www.instagram.com/saptadipdutta/",
          role : "Hybrid",
          exp: "",
          name: "Saptadip Dutta"
      },
      ala : {
          dp : require("../images/member/ala.jpg"),
          fb : "https://www.facebook.com/alapan.ganguly.5",
          insta : "https://www.instagram.com/alapan_ganguly/",
          role : "Backend Support",
          exp: "Since 2016",
          name: "Alapan Ganguly"
      },
      atanu : {
          dp : require("../images/member/ATANU.webp"),
          fb : "https://www.facebook.com/atanu.das.461950",
          insta : "https://www.instagram.com/atanu859?igsh=MXJpbjVkbXJ6bzV4bg==",
          role : "Hybrid",
          exp: "",
          name: "Atanu"
      },
      sougata : {
          dp : require("../images/member/SOUGATA.webp"),
          fb : "https://www.facebook.com/rokz.sougata1",
          insta : "https://www.instagram.com/sougatamal/",
          role : "Photographer",
          exp: "",
          name: "Sougata"
      },
      akash : {
          dp : require("../images/member/AKASH.webp"),
          fb : "https://www.facebook.com/akash.arb.2025",
          insta : "https://www.instagram.com/iam.akash0605/",
          role : "Hybrid",
          exp: "",
          name: "Akash"
      },
      pritambar : {
          dp : require("../images/member/PRITAMBAR.webp"),
          fb : "https://www.facebook.com/ghosh.pritambar",
          insta : "https://www.instagram.com/pritambar_ghosh_photography/",
          role : "Hybrid",
          exp: "",
          name: "Pritambar"
      },
      ranajit : {
          dp : require("../images/member/RANAJIT.webp"),
          fb : "https://www.facebook.com/ronit.dey.7739",
          insta : "https://www.instagram.com/ronit_studio/",
          role : "Hybrid",
          exp: "",
          name: "Ranajit"
      },
      rahul : {
          dp : require("../images/member/RAHUL.webp"),
          fb : "https://www.facebook.com/rahul.sarkar.31739",
          insta : "https://www.instagram.com/im.rahul.2012/",
          role : "Hybrid",
          exp: "",
          name: "Rahul"
      },
      dipak : {
          dp : require("../images/member/DIPAK.webp"),
          fb : "https://www.facebook.com/dipak.modak.5243",
          insta : "https://www.instagram.com/dipak.modak.5243/",
          role : "Hybrid",
          exp: "",
          name: "Dipak"
      },
      shreyashi : {
          dp : require("../images/member/SHREYASHI.webp"),
          fb : "https://www.facebook.com/shreyashi.sadhukhan.77",
          insta : "https://www.instagram.com/Shreyashi_official_03",
          role : "Photographer",
          exp: "",
          name: "Shreyashi"
      },
      debjyoti : {
          dp : require("../images/member/DEBJYOTI.webp"),
          fb : "https://www.facebook.com/debjyoti.roy.77377",
          insta : "https://www.instagram.com/debjyoti363",
          role : "Photographer",
          exp: "",
          name: "Debjyoti"
      },
      abhijit : {
          dp : require("../images/member/ABHIJIT.webp"),
          fb : "https://www.facebook.com/dis.is.abhijit",
          insta : "https://www.instagram.com/dis_is_abhijit",
          role : "Hybrid",
          exp: "",
          name: "Abhijit"
      },
      supriyo : {
          dp : require("../images/member/SUPRIYO.webp"),
          fb : "https://www.facebook.com/supriyoroy.chowdhury.754",
          insta : "https://www.instagram.com/S_h_a_m_m_o_",
          role : "Photographer",
          exp: "",
          name: "Supriyo"
      },
      subhankar : {
          dp : require("../images/member/SUBHANKAR.webp"),
          fb : "https://www.facebook.com/subho.subhankarroy.3",
          insta : "https://www.instagram.com/gogol_mistu",
          role : "Photographer",
          exp: "",
          name: "Subhankar"
      },
      asrafull : {
          dp : require("../images/member/ASRAFULL.webp"),
          fb : "https://www.facebook.com/asrafull.biswas.1",
          insta : "https://www.instagram.com/abphotography245/",
          role : "Photographer",
          exp: "",
          name: "Asrafull"
      },
  },
  addDetails : {
      bannerUrl : "https://firebasestorage.googleapis.com/v0/b/weddingstoriess-person.appspot.com/o/modal-add%2F7140749.jpg?alt=media&token=03faf2f1-3ecc-45a4-a79f-30afa3da9f6d&_gl=1*u8ehmt*_ga*Mzc0MDI3NzE1LjE2ODE0NDI3Mjg.*_ga_CW55HF8NVT*MTY5OTA3NjAwOS4yMy4xLjE2OTkwNzc3MTMuNjAuMC4w"
  },
  galleryImages : [
    { src: require("../images/gallery/1 copy.webp"), width: 6000, height: 6000 },
    { src: require("../images/gallery/1.webp"), width: 6000, height: 3000 },
    { src: require("../images/gallery/2 copy.webp"), width: 6000, height: 6000 },
    { src: require("../images/gallery/2.webp"), width: 6000, height: 6000 },
    { src: require("../images/gallery/BRO00134.webp"), width: 3436, height: 5155 },
    { src: require("../images/gallery/BRO01753.webp"), width: 4087, height: 2725 },
    { src: require("../images/gallery/BRO01765.webp"), width: 7991, height: 5328 },
    { src: require("../images/gallery/BRO01773.webp"), width: 6576, height: 4384 },
    { src: require("../images/gallery/BRO01804.webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/DSC03967.webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/DSC03969.webp"), width: 5783, height: 3856 },
    { src: require("../images/gallery/DSC03971.webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/DSC03975.webp"), width: 4000, height: 6000 },
    { src: require("../images/gallery/DSC03978 copy.webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/DSC03978.webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/DSC05728 copy.webp"), width: 3684, height: 5525 },
    { src: require("../images/gallery/DSC05728.webp"), width: 3684, height: 5525 },
    { src: require("../images/gallery/DSC05796.webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/DSC05799.webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/DSC05800.webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/DSC05811.webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/DSC05814.webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/DSC05837.webp"), width: 4000, height: 6000 },
    { src: require("../images/gallery/DSC05839.webp"), width: 4000, height: 6000 },
    { src: require("../images/gallery/DSC05842.webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/DSC05844.webp"), width: 6533, height: 4356 },
    { src: require("../images/gallery/DSC05928.webp"), width: 5650, height: 3767 },
    { src: require("../images/gallery/DSC05931.webp"), width: 5303, height: 3535 },
    { src: require("../images/gallery/DSC06053.webp"), width: 5809, height: 3873 },
    { src: require("../images/gallery/DSC06055.webp"), width: 5646, height: 3764 },
    { src: require("../images/gallery/DSC06057.webp"), width: 6001, height: 4000 },
    { src: require("../images/gallery/DSC06067.webp"), width: 4000, height: 6000 },
    { src: require("../images/gallery/DSC06118.webp"), width: 4000, height: 6000 },
    { src: require("../images/gallery/DSC06119.webp"), width: 4000, height: 6000 },
    { src: require("../images/gallery/DSC06131.webp"), width: 4000, height: 6000 },
    { src: require("../images/gallery/DSC06132.webp"), width: 4000, height: 6000 },
    { src: require("../images/gallery/DSC06375.webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/DSC06450.webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/DSC06456.webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/DSC06459.webp"), width: 6701, height: 4406 },
    { src: require("../images/gallery/DSC06473.webp"), width: 11794, height: 4633 },
    { src: require("../images/gallery/DSC06478(1).webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/DSC08773.webp"), width: 3923, height: 5884 },
    { src: require("../images/gallery/DSC08775.webp"), width: 4000, height: 6000 },
    { src: require("../images/gallery/DSC08776.webp"), width: 3874, height: 5811 },
    { src: require("../images/gallery/DSC08780.webp"), width: 3411, height: 5117 },
    { src: require("../images/gallery/DSC08783.webp"), width: 6912, height: 4608 },
    { src: require("../images/gallery/DSC08785.webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/DSC08787.webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/DSC_0006.webp"), width: 3864, height: 5796 },
    { src: require("../images/gallery/DSC_1326 copy.webp"), width: 3587, height: 5380 },
    { src: require("../images/gallery/DSC_1337 copy.webp"), width: 5568, height: 3712 },
    { src: require("../images/gallery/DSC_1341 copy.webp"), width: 3483, height: 5225 },
    { src: require("../images/gallery/DSC_1351 copy.webp"), width: 3641, height: 5461 },
    { src: require("../images/gallery/DSC_1353 copy.webp"), width: 3469, height: 5203 },
    { src: require("../images/gallery/DSC_1358 copy.webp"), width: 5074, height: 3383 },
    { src: require("../images/gallery/DSC_1361 copy.webp"), width: 3712, height: 5568 },
    { src: require("../images/gallery/DSC_1370 copy.webp"), width: 5379, height: 3586 },
    { src: require("../images/gallery/DSC_1474 copy.webp"), width: 3712, height: 5568 },
    { src: require("../images/gallery/DSC_1485 copy.webp"), width: 3712, height: 5568 },
    { src: require("../images/gallery/DSC_1497 copy.webp"), width: 3712, height: 5568 },
    { src: require("../images/gallery/DSC_1514 copy.webp"), width: 5568, height: 3712 },
    { src: require("../images/gallery/DSC_1517 copy.webp"), width: 5568, height: 3712 },
    { src: require("../images/gallery/DSC_1525 copy.webp"), width: 5568, height: 3712 },
    { src: require("../images/gallery/DSC_1553 copy.webp"), width: 5568, height: 3712 },
    { src: require("../images/gallery/DSC_1559 copy.webp"), width: 5568, height: 3712 },
    { src: require("../images/gallery/DSC_1562 copy.webp"), width: 5568, height: 3712 },
    { src: require("../images/gallery/DSC_1620 copy.webp"), width: 5568, height: 3712 },
    { src: require("../images/gallery/DSC_1636 copy.webp"), width: 3578, height: 5367 },
    { src: require("../images/gallery/DSC_1641 copy.webp"), width: 3712, height: 5568 },
    { src: require("../images/gallery/DSC_1642 copy.webp"), width: 3528, height: 5293 },
    { src: require("../images/gallery/DSC_1644 copy.webp"), width: 3513, height: 5270 },
    { src: require("../images/gallery/DSC_1647 copy.webp"), width: 5568, height: 3712 },
    { src: require("../images/gallery/DSC_1651 copy.webp"), width: 5487, height: 3658 },
    { src: require("../images/gallery/DSC_1652 copy.webp"), width: 5568, height: 3712 },
    { src: require("../images/gallery/DSC_1672 copy.webp"), width: 3712, height: 5568 },
    { src: require("../images/gallery/DSC_1675 copy.webp"), width: 3514, height: 5271 },
    { src: require("../images/gallery/DSC_1677 copy.webp"), width: 3712, height: 5568 },
    { src: require("../images/gallery/DSC_1679 copy.webp"), width: 3712, height: 5568 },
    { src: require("../images/gallery/DSC_1680 copy.webp"), width: 3547, height: 5321 },
    { src: require("../images/gallery/DSC_1859 copy.webp"), width: 5568, height: 3712 },
    { src: require("../images/gallery/DSC_1876 copy.webp"), width: 5162, height: 3442 },
    { src: require("../images/gallery/DSC_1887 copy.webp"), width: 5568, height: 3712 },
    { src: require("../images/gallery/DSC_1940 copy.webp"), width: 3712, height: 5568 },
    { src: require("../images/gallery/DSC_1951 copy.webp"), width: 5568, height: 3712 },
    { src: require("../images/gallery/DSC_1962 copy.webp"), width: 3712, height: 5568 },
    { src: require("../images/gallery/DSC_1963 copy.webp"), width: 3712, height: 5568 },
    { src: require("../images/gallery/DSC_1969 copy.webp"), width: 3712, height: 5568 },
    { src: require("../images/gallery/DSC_1986 copy.webp"), width: 3499, height: 5248 },
    { src: require("../images/gallery/DSC_1989 copy.webp"), width: 3291, height: 4936 },
    { src: require("../images/gallery/DSC_1990 copy.webp"), width: 3137, height: 4705 },
    { src: require("../images/gallery/DSC_1996 copy.webp"), width: 3220, height: 4831 },
    { src: require("../images/gallery/DSC_1997 copy.webp"), width: 3712, height: 5568 },
    { src: require("../images/gallery/DSC_2005 copy.webp"), width: 3712, height: 5568 },
    { src: require("../images/gallery/DSC_2007 copy.webp"), width: 3712, height: 5568 },
    { src: require("../images/gallery/DSC_2012 copy.webp"), width: 3712, height: 5568 },
    { src: require("../images/gallery/GBS00762.webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/GBS00763.webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/GBS00764.webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/GBS00767.webp"), width: 4000, height: 6000 },
    { src: require("../images/gallery/GBS00773.webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/GBS00780.webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/GBS00787.webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/GBS00811.webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/GBS00813.webp"), width: 5824, height: 3883 },
    { src: require("../images/gallery/GBS00826.webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/GBS03336.webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/GBS07345.webp"), width: 6683, height: 4455 },
    { src: require("../images/gallery/WSS_0009DSC01250.webp"), width: 5469, height: 3646 },
    { src: require("../images/gallery/WSS_0009DSC01308.webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/WSS_0009DSC07093.webp"), width: 5851, height: 3901 },
    { src: require("../images/gallery/WSS_0009DSC07095.webp"), width: 5827, height: 3884 },
    { src: require("../images/gallery/WSS_0009DSC07103.webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/WSS_0009DSC07110.webp"), width: 5905, height: 3937 },
    { src: require("../images/gallery/WSS_0009DSC07112.webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/WSS_0009DSC07116.webp"), width: 3812, height: 5718 },
    { src: require("../images/gallery/WSS_0009DSC07119.webp"), width: 5703, height: 3802 },
    { src: require("../images/gallery/WSS_0009DSC07121.webp"), width: 3862, height: 5792 },
    { src: require("../images/gallery/WSS_0009DSC07122.webp"), width: 4310, height: 6465 },
    { src: require("../images/gallery/WSS_0009DSC07146.webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/WSS_0009DSC07148.webp"), width: 7474, height: 4983 },
    { src: require("../images/gallery/WSS_0009DSC07152.webp"), width: 5644, height: 3762 },
    { src: require("../images/gallery/WSS_0009DSC07163.webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/WSS_0009DSC07169.webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/WSS_0009DSC07176.webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/WSS_0009DSC07187.webp"), width: 4000, height: 6000 },
    { src: require("../images/gallery/WSS_0009DSC07190.webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/WSS_0009DSC07198.webp"), width: 4000, height: 6000 },
    { src: require("../images/gallery/WSS_0009DSC07205.webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/WSS_0009DSC07208.webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/WSS_0009DSC07210.webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/WSS_0009DSC07215.webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/WSS_0009DSC07219.webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/WSS_0009DSC07222.webp"), width: 4000, height: 6000 },
    { src: require("../images/gallery/WSS_0009DSC07225.webp"), width: 4000, height: 6000 },
    { src: require("../images/gallery/WSS_0009DSC07227.webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/WSS_0009DSC07246.webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/WSS_0009DSC07276.webp"), width: 4000, height: 6000 },
    { src: require("../images/gallery/WSS_0009DSC07293.webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/WSS_0009DSC07307.webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/WSS_0009DSC07313.webp"), width: 4000, height: 6000 },
    { src: require("../images/gallery/WSS_0009DSC07314.webp"), width: 4000, height: 6000 },
    { src: require("../images/gallery/WSS_0009DSC07320.webp"), width: 5658, height: 3772 },
    { src: require("../images/gallery/WSS_0009DSC07331.webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/WSS_0009DSC07333.webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/WSS_0009DSC07334.webp"), width: 5883, height: 3922 },
    { src: require("../images/gallery/WSS_0009DSC07337.webp"), width: 5490, height: 3660 },
    { src: require("../images/gallery/WSS_0009DSC07344.webp"), width: 4000, height: 6000 },
    { src: require("../images/gallery/WSS_0009DSC07350.webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/WSS_0009DSC07355.webp"), width: 4000, height: 6000 },
    { src: require("../images/gallery/WSS_0009DSC_0006.webp"), width: 3864, height: 5796 },
    { src: require("../images/gallery/WSS_0009DSC_0022.webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/WSS_0009DSC_0026 (2).webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/WSS_0009DSC_0032.webp"), width: 4000, height: 6000 },
    { src: require("../images/gallery/WSS_0009DSC_0042.webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/WSS_0009DSC_0096.webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/WSS_0009DSC_0112.webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/WSS_0009DSC_0116 (2).webp"), width: 4000, height: 6000 },
    { src: require("../images/gallery/WSS_0009DSC_0120.webp"), width: 3423, height: 5135 },
    { src: require("../images/gallery/WSS_0009DSC_0131.webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/WSS_0009DSC_0133.webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/WSS_0009DSC_0153.webp"), width: 5749, height: 3832 },
    { src: require("../images/gallery/WSS_0009DSC_0192.webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/WSS_0009DSC_0193.webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/WSS_0009DSC_0194.webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/WSS_0009DSC_0197.webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/WSS_0009DSC_0216.webp"), width: 5886, height: 3924 },
    { src: require("../images/gallery/WSS_0009DSC_0285.webp"), width: 3787, height: 5680 },
    { src: require("../images/gallery/WSS_0009DSC_1275.webp"), width: 3718, height: 5588 },
    { src: require("../images/gallery/WSS_0009DSC_1278.webp"), width: 6048, height: 4024 },
    { src: require("../images/gallery/WSS_0009DSC_1306.webp"), width: 4024, height: 6048 },
    { src: require("../images/gallery/WSS_0009DSC_1312.webp"), width: 4024, height: 6048 },
    { src: require("../images/gallery/WSS_0009DSC_1318.webp"), width: 6048, height: 4024 },
    { src: require("../images/gallery/WSS_0009DSC_1322.webp"), width: 4024, height: 6048 },
    { src: require("../images/gallery/WSS_0009DSC_1336.webp"), width: 5916, height: 3936 },
    { src: require("../images/gallery/WSS_0009DSC_2189.webp"), width: 6048, height: 4024 },
    { src: require("../images/gallery/WSS_0009DSC_2191.webp"), width: 3862, height: 5804 },
    { src: require("../images/gallery/WSS_0009DSC_2195.webp"), width: 6048, height: 4024 },
    { src: require("../images/gallery/WSS_0009DSC_2299.webp"), width: 4024, height: 6048 },
    { src: require("../images/gallery/WSS_0009DSC_2305.webp"), width: 6048, height: 4024 },
    { src: require("../images/gallery/WSS_0009DSC_2307.webp"), width: 6048, height: 4024 },
    { src: require("../images/gallery/WSS_0009DSC_2428.webp"), width: 4024, height: 6048 },
    { src: require("../images/gallery/WSS_0009DSC_2434.webp"), width: 6048, height: 4024 },
    { src: require("../images/gallery/WSS_0009DSC_2436.webp"), width: 6048, height: 4024 },
    { src: require("../images/gallery/WSS_0009DSC_2441.webp"), width: 6048, height: 4024 },
    { src: require("../images/gallery/WSS_0009DSC_2558.webp"), width: 6048, height: 4024 },
    { src: require("../images/gallery/WSS_0009DSC_2559.webp"), width: 5741, height: 3820 },
    { src: require("../images/gallery/WSS_0009DSC_2564.webp"), width: 6048, height: 4024 },
    { src: require("../images/gallery/WSS_0009DSC_2565.webp"), width: 6048, height: 4024 },
    { src: require("../images/gallery/WSS_0009DSC_2566.webp"), width: 6048, height: 4024 },
    { src: require("../images/gallery/WSS_0009DSC_2675.webp"), width: 6048, height: 4024 },
    { src: require("../images/gallery/WSS_0009DSC_2778.webp"), width: 4024, height: 6048 },
    { src: require("../images/gallery/WSS_0009DSC_2779.webp"), width: 3652, height: 5490 },
    { src: require("../images/gallery/WSS_0009DSC_2881.webp"), width: 6048, height: 4024 },
    { src: require("../images/gallery/WSS_0009DSC_2882.webp"), width: 6048, height: 4024 },
    { src: require("../images/gallery/WSS_0009DSC_2912.webp"), width: 6048, height: 4024 },
    { src: require("../images/gallery/WSS_0009DSC_2913.webp"), width: 6048, height: 4024 },
    { src: require("../images/gallery/WSS_0009DSC_2916.webp"), width: 6048, height: 4024 },
    { src: require("../images/gallery/WSS_0009DSC_2918.webp"), width: 6048, height: 4024 },
    { src: require("../images/gallery/WSS_0009DSC_2924.webp"), width: 3901, height: 5863 },
    { src: require("../images/gallery/WSS_0009DSC_2926.webp"), width: 6048, height: 4024 },
    { src: require("../images/gallery/WSS_0009DSC_2927.webp"), width: 4024, height: 6048 },
    { src: require("../images/gallery/WSS_0009DSC_2930.webp"), width: 6048, height: 4024 },
    { src: require("../images/gallery/WSS_0009DSC_2931.webp"), width: 6048, height: 4024 },
    { src: require("../images/gallery/WSS_0009DSC_2932.webp"), width: 5741, height: 3820 },
    { src: require("../images/gallery/WSS_0009DSC_2934.webp"), width: 5929, height: 3563 },
    { src: require("../images/gallery/WSS_0009DSC_4874.webp"), width: 5568, height: 3712 },
    { src: require("../images/gallery/WSS_0009DSC_4882.webp"), width: 5568, height: 3712 },
    { src: require("../images/gallery/WSS_0009DSC_4967.webp"), width: 5568, height: 3712 },
    { src: require("../images/gallery/WSS_0009DSC_4969.webp"), width: 5568, height: 3712 },
    { src: require("../images/gallery/WSS_0009DSC_4977.webp"), width: 5568, height: 3712 },
    { src: require("../images/gallery/WSS_0009DSC_5013.webp"), width: 5568, height: 3712 },
    { src: require("../images/gallery/WSS_0009DSC_5086.webp"), width: 5568, height: 3712 },
    { src: require("../images/gallery/WSS_0009DSC_5209.webp"), width: 5568, height: 3712 },
    { src: require("../images/gallery/WSS_0009DSC_5218.webp"), width: 5568, height: 3712 },
    { src: require("../images/gallery/WSS_0009DSC_5220.webp"), width: 5568, height: 3712 },
    { src: require("../images/gallery/WSS_0009DSC_5224.webp"), width: 5568, height: 3712 },
    { src: require("../images/gallery/WSS_0009DSC_5407.webp"), width: 5568, height: 3712 },
    { src: require("../images/gallery/WSS_0009DSC_5448.webp"), width: 5568, height: 3712 },
    { src: require("../images/gallery/WSS_0009DSC_5453.webp"), width: 5568, height: 3712 },
    { src: require("../images/gallery/WSS_0009DSC_5454.webp"), width: 3407, height: 5110 },
    { src: require("../images/gallery/WSS_0009DSC_5473.webp"), width: 3465, height: 5197 },
    { src: require("../images/gallery/WSS_0009DSC_5495.webp"), width: 5568, height: 3712 },
    { src: require("../images/gallery/WSS_0009DSC_5496.webp"), width: 5568, height: 3712 },
    { src: require("../images/gallery/WSS_0009DSC_5502.webp"), width: 5568, height: 3712 },
    { src: require("../images/gallery/WSS_0009DSC_5513.webp"), width: 3712, height: 5568 },
    { src: require("../images/gallery/WSS_0009DSC_5519.webp"), width: 3712, height: 5568 },
    { src: require("../images/gallery/WSS_0009DSC_5541.webp"), width: 5568, height: 3712 },
    { src: require("../images/gallery/WSS_0009DSC_5544.webp"), width: 5568, height: 3712 },
    { src: require("../images/gallery/WSS_0009DSC_5612.webp"), width: 5568, height: 3712 },
    { src: require("../images/gallery/WSS_0009DSC_6769.webp"), width: 3712, height: 5568 },
    { src: require("../images/gallery/WSS_0009DSC_6774.webp"), width: 3712, height: 5568 },
    { src: require("../images/gallery/WSS_0009DSC_6780.webp"), width: 5568, height: 3712 },
    { src: require("../images/gallery/WSS_0009DSC_6784.webp"), width: 3712, height: 5568 },
    { src: require("../images/gallery/WSS_0009DSC_6788.webp"), width: 5568, height: 3712 },
    { src: require("../images/gallery/WSS_0009DSC_6789.webp"), width: 3712, height: 5568 },
    { src: require("../images/gallery/WSS_0009DSC_6790.webp"), width: 3712, height: 5568 },
    { src: require("../images/gallery/WSS_0009DSC_6791.webp"), width: 3712, height: 5568 },
    { src: require("../images/gallery/WSS_0009GBS03319.webp"), width: 6000, height: 4000 },
    { src: require("../images/gallery/WSS_0009GBS03324.webp"), width: 5669, height: 3779 },
  ]
};

export default metaData;